export default function jumpToSectionsController() {
  const jumpToSections = document.getElementsByClassName('jump-to-sections');

  if (!jumpToSections || !jumpToSections.length) {
    return;
  }

  let jumpToSectionsHTML = '';

  const targetElements = document.querySelectorAll('[data-display-in-jump-to-sections="true"]');

  if (!targetElements || !targetElements.length) {
    return;
  }

  targetElements.forEach((targetElement) => {
    const title = targetElement.dataset.title;
    const id = targetElement.id;

    if (!id) {
      return;
    }

    jumpToSectionsHTML += `<a href="#${id}">${title}</a>`;
  });

  for (jumpToContainer of jumpToSections) {
    jumpToContainer.innerHTML = jumpToSectionsHTML;
  }

  if (window.product) {
    document.addEventListener(`product-rating-loaded`, (event) => {
      const productId = event.detail.id;
      const count = event.detail.count;

      if (productId != window.product.productId) {
        return;
      }

      if (count > 0) {
        return;
      }

      const customerReviewsJumpToBox = document.querySelectorAll('a[href="#customer-reviews"]');
      if (!customerReviewsJumpToBox || !customerReviewsJumpToBox.length) {
        return;
      }

      customerReviewsJumpToBox.forEach((customerReviewsJumpToBox) => {
        customerReviewsJumpToBox.style.display = 'none';
      });
    });
  }
}
